import { actions } from './warehouseProduct/actions'
import { getters } from './warehouseProduct/getters'
import { state } from './warehouseProduct/state'
import { mutations } from './warehouseProduct/mutations'

export default {
    namespaced: true,
    getters,
    state,
    mutations,
    actions
}
